import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { finalize, tap } from 'rxjs/operators';

import { Subscription } from 'rxjs';
import { UserRepository } from '@state/user';
import { ZendeskService } from '@state/zendesk';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { InlineSvgDirective } from '../../directives/inline-svg/inline-svg.directive';
import { LabeledHorizontalSeparatorComponent } from '../../component/labeled-horizontal-separator/labeled-horizontal-separator.component';

@Component({
  encapsulation: ViewEncapsulation.None,
  imports: [InlineSvgDirective, LabeledHorizontalSeparatorComponent, RouterLink, AsyncPipe],
  selector: 'fl-four-oh-four',
  styleUrls: ['./four-oh-four.component.scss'],
  templateUrl: './four-oh-four.component.html'
})
export class FourOhFourComponent implements OnInit, OnDestroy {
  private userRepository = inject(UserRepository);
  zendeskService = inject(ZendeskService);

  isUserLoggedIn$ = this.userRepository.hasFetchedUser$;
  isUserLoggedInSubscription: Subscription;
  isZendeskWidgetHidden = false;
  user$ = this.userRepository.user$;

  ngOnInit() {
    this.isUserLoggedInSubscription = this.isUserLoggedIn$
      .pipe(
        tap({
          next: (isUserLoggedIn) => {
            if (!isUserLoggedIn) {
              this.isZendeskWidgetHidden = true;
              this.zendeskService.toggleZendeskWidgetDisplay();
            }
          }
        }),
        finalize(() => {
          if (this.isZendeskWidgetHidden) this.zendeskService.toggleZendeskWidgetDisplay();
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.isUserLoggedInSubscription.unsubscribe();
  }
}
